import React from 'react';

function Dummy() {
  return <div>TBD</div>;
}

export default Dummy;
